// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const ToggleCheckboxesButton = props => props.listLength >= 3 ?
    <button
        onClick={props.onClick}
        type='button'
    >
        <FormattedMessage id={props.label}/>
    </button> :
    null;

ToggleCheckboxesButton.displayName = 'ToggleCheckboxesButton';
ToggleCheckboxesButton.propTypes = {
    label: PropTypes.string.isRequired,
    listLength: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired
};

export default ToggleCheckboxesButton;



// WEBPACK FOOTER //
// ./src/shared/components/toggle-checkboxes-button/index.js